define(
    'viewmodels/secured/explorer/navigation/libraries/libraries',[
        "viewmodels/secured/explorer/context",
        "viewmodels/ViewModel",
        "viewmodels/secured/explorer/navigation/libraries/Library",
        "services/eventbroker",
        "plugins/router",
        "services/config",
        "providers/dataprovider",
        "i19n!i19n/strings",        
        "viewmodels/secured/explorer/navigation/menu",
        "viewmodels/secured/explorer/navigation/libraries/accessFolder",
        "viewmodels/secured/explorer/navigation/libraries/accessList",
        "viewmodels/secured/explorer/navigation/libraries/accessLibrary",

        "viewmodels/secured/explorer/navigation/libraries/LibraryFolderTemplate",
        "viewmodels/secured/explorer/navigation/libraries/FolderActionsFolderTemplate",
        "viewmodels/controller",

        // modules don't return anything. they are ko binding handlers.
        "extensions/knockout/fp_list_grid"
    ],
    function (ctx, ViewModel, Library, eventBroker, router, config, dataProvider, i19n, menu, accessControlFolder, accessControlList, accessControlLibrary, LibraryFolderTemplate, LibraryFolderTemplateActions, controller) {
        var $wndFolder = null;
        var wndFolder = null;
        var $wndList = null;
        var wndList = null;
        var $wndLibrary = null;
        var wndLibrary = null;

        var pressTimer = null;

        var vm = new ViewModel(
        {
            i19n: i19n,
            menu: menu,

            isEdit: ko.observable(false),
            accessControlFolder: accessControlFolder,
            accessControlList: accessControlList,
            accessControlLibrary: accessControlLibrary,
            libraries: ko.observableArray([]),
            selectedLibrary: ko.observable(),
            isAdmin: ko.observable(false),
            isGuest: ko.observable(false)
        });

        ctx.onReloadFolders.subscribe(function (data) {
            refresh(function () { }, data);
        });
        ctx.onListValueFilter.subscribe(function (data) {
            var library = ctx.current.library;

            if (library && data.q.length == 0) {
                library.treeData.deselect();
            }
        });
        ctx.onNavFolder.subscribe(function () {
            if (vm.selectedLibrary()) {
                vm.selectedLibrary().isBeingRenamed(false);
            }
        });

        vm.activate = function () {
            vm.isAdmin(vm.session.role == 3 || vm.session.role == 4 ? true : false);
            vm.isGuest(vm.session.role == 0 || vm.session.role == 1 ? true : false);

            return $.Deferred().resolve();

            //if (vm.libraries().length)
            //    return $.Deferred().resolve();

            //return vm.loadLibraries();
        };
        vm.attached = function () {
            $wndFolder = $("#navigation-accesscontrol-folder-window");
            wndFolder = $wndFolder.kendoWindow({
                title: i19n.to.folderaccesscontrol,
                modal: true,
                visible: false,
                resizable: false,
                width: 1090,
                height: 680
            }).data('kendoWindow');

            $wndList = $("#navigation-accesscontrol-list-window");
            wndList = $wndList.kendoWindow({
                title: i19n.to.listaccesscontrol,
                modal: true,
                visible: false,
                resizable: false,
                width: 1090,
                height: 680
            }).data('kendoWindow');

            $wndLibrary = $("#navigation-accesscontrol-library-window");
            wndLibrary = $wndLibrary.kendoWindow({
                title: i19n.to.libraryaccesscontrol,
                modal: true,
                visible: false,
                resizable: false,
                width: 1090,
                height: 680
            }).data('kendoWindow');

            vm.loadLibraries()
            .done(function () {
                _.map(vm.libraries(), function (library) {
                    var $library = $("#gp-lib-library-id-" + library.libraryId);

                    $library.off("mouseup", "**");
                    $library.on("mouseup", function () {

                        clearTimeout(pressTimer);

                        return false;
                    });

                    $library.off("mousedown", "**");
                    $library.on("mousedown", function () {
                        pressTimer = window.setTimeout(function () {
                            library.isBeingRenamed(true);

                            var $input = $("#gp-lib-library-input-id-" + library.libraryId);

                            $input.val(library.label());

                            $input.unbind("keyup");
                            $input.keyup(function (e) {
                                if (e.keyCode == 27) {
                                    library.isBeingRenamed(false);
                                }
                            });
                            $input.unbind("keypress");
                            $input.keypress(function (e) {
                                if (e.which == 13) {
                                    var newLabel = $(this).val();
                                    var oldLabel = library.label();

                                    if (newLabel == "" || oldLabel == newLabel) {
                                        library.isBeingRenamed(false);

                                        return;
                                    }

                                    dataProvider.libraries
                                    .updateName(library.libraryId, newLabel)
                                    .done(function (data) {
                                        library.label(newLabel);
                                        library.name = newLabel;
                                        library.isBeingRenamed(false);

                                        vm.refresh();
                                    })
                                    .fail(function (e) {
                                        console.error(e);
                                    });
                                }
                            });
                        }, 1500);

                        //return false;
                    });

                    var _dtrap = function (e) {
                        var container = $("#gp-lib-library-id-" + library.libraryId);

                        // if the target of the click isn't the container... // ... nor a descendant of the container
                        if (!container.is(e.target) && container.has(e.target).length === 0) {
                            //container.hide();
                            library.isBeingRenamed(false);
                        }
                    };
                    $(document).off("mouseup", _dtrap);
                    $(document).on("mouseup", _dtrap);
                });
            });                   
        };

        //#region Access Control Folder
        vm.accessControlFolderShow = function (id) {
            vm.accessControlFolder
            .loadAccess(id)
            .done(function () {
                vm.isEdit(false);

                setTimeout(function () {
                    wndFolder.title(i19n.to.folderaccesscontrol);
                    wndFolder.center().open();
                }, 500);
            })
            .fail(function (e) {
                ctx.current.listValue = null;
                ctx.current.library.list.active.selectedRow(null);

                refresh(function () { }, null);
            });
        };
        vm.saveAccessControlFolder = function () {
            vm.accessControlFolder.saveClick()
            .done(function () {
                wndFolder.center().close();
            });
        };
        vm.closeAccessControlFolder = function () {
            vm.accessControlFolder.cancelClick();
            wndFolder.center().close();
        };
        vm.inheritAccessControlFolder = function () {
            vm.accessControlFolder.isInherited(true);
            vm.accessControlFolder.inherit()
            .done(function () {
                wndFolder.center().close();
            });
        };
        //vm.editAccessControlFolder = function () {
        //    vm.isEdit(!vm.isEdit());
        //    vm.accessControlFolder.editClick(vm.isEdit());
        //};
        //#endregion

        //#region Access Control List
        vm.accessControlListShow = function (id) {
            vm.accessControlList
            .loadAccess(id)
            .done(function () {
                vm.isEdit(false);

                setTimeout(function () {
                    wndList.title(i19n.to.listaccesscontrol);
                    wndList.center().open();
                }, 500);
            })
            .fail(function (e) {
                ctx.current.listValue = null;
                ctx.current.library.list.active.selectedRow(null);

                refresh(function () { }, null);
            });
        };
        vm.saveAccessControlList = function () {
            vm.accessControlList.saveClick()
            .done(function () {
                wndList.center().close();
            });
        };
        vm.closeAccessControlList = function () {
            vm.accessControlList.cancelClick();
            wndList.center().close();
        };

        //#endregion

        //#region Access Control Library
        vm.libraryAccessControlShow = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                if (!ctx.current || !ctx.current.library) {
                    complete();

                    return;
                }

                var id = ctx.current.library.libraryId;
                
                vm.accessControlLibrary
               .loadAccess(id)
               .done(function () {
                   vm.isEdit(false);

                   setTimeout(function () {
                       wndLibrary.title(i19n.to.libraryaccesscontrol);
                       wndLibrary.center().open();
                   }, 500);
               })
               .fail(function (e) {
                   ctx.current.listValue = null;
                   ctx.current.library.list.active.selectedRow(null);

                   refresh(function () { }, null);
               })
                .always(function () {
                    complete();
                });
            }
        });

        vm.saveAccessControlLibrary = function () {
            vm.accessControlLibrary.saveClick()
            .done(function () {
                wndLibrary.center().close();
            });
        };
        vm.closeAccessControlLibrary = function () {
            vm.accessControlLibrary.cancelClick();
            wndLibrary.center().close();
        };
        //#endregion
              
        vm.loadLibraries = function (settings) {
            var d = $.Deferred();

            controller.isBusy(true, null, 1);

            dataProvider.libraries.getLibraries()
            .fail(function (e) {
                d.reject(e);
            })
            .always(function (libraries) {
                libraries = _.sortBy(libraries, function (library) { return library.name; });
                
                if (vm.isGuest()) {
                    libraries = _.map(libraries, function (library) {
                        var lib = new Library(library.libraryId, library.name, library.listId, '', i19n, vm.accessControlFolderShow, vm.accessControlListShow, vm.folderSelected, vm.isAdmin());

                        lib.infoText('');
                        lib.folderTemplate = null;

                        lib.menuItem = new menu.Item(true, 'library');
                        lib.menuItem.libraryId = library.libraryId;
                        menu.items().push(lib.menuItem);

                        return lib;
                    });

                    vm.libraries(libraries);

                    d.resolve(libraries);

                    var q1 = _.find(menu.items(), function (itm) {
                        return itm.id == "library" && itm.libraryId && itm.libraryId == sessionStorage.__url_libraryId;
                    });
                    var q2 = _.find(libraries, function (itm) {
                        return itm.libraryId == sessionStorage.__url_libraryId;
                    });  

                    if (q1 && q2) {
                        menu.itemSelected(q1);
                        vm.selectedLibrary(q2);

                        _librarySelected(q2, function () {
                            controller.isBusy(false);
                        });
                    } else {
                        controller.isBusy(false);
                    }
                } else {
                    var promises = [];

                    _.map(libraries, function (library) {
                        promises.push(dataProvider.libraries.getSettings(library.libraryId));
                    });

                    $.when.apply($, promises)
                    .then(function () {
                        var settings = arguments;

                        libraries = _.map(libraries, function (library) {
                            var __set = _.find(settings, function (itm) {
                                if (itm == 200) return false;

                                if (itm.libraryId === undefined) 
                                    return itm[0].libraryId == library.libraryId;
                                else 
                                    return itm.libraryId == library.libraryId;
                            });
                            
                            var setting = __set.constructor === Array ? __set[0] : (__set ? __set : null);
                            var lib = null;
                            
                            if (library.listId != null && setting) {
                                lib = new Library(library.libraryId, library.name, library.listId, setting ? setting.listName : '', i19n, vm.accessControlFolderShow, vm.accessControlListShow, function (folder, sender) {                                    
                                    if (!sender && sender != "folderaction") {
                                        vm.folderSelected(folder);
                                    }
                                }, vm.isAdmin());

                                setting.libraryTemplates = _.sortBy(setting.libraryTemplates, function (itm) { return itm ? itm.name : ""; });

                                lib.infoText(String.format(i19n.to.addfolderstobeautomaticallycreatedunderevery, setting.listName));
                                lib.folderTemplate = new LibraryFolderTemplate(lib.libraryId, setting.libraryTemplates[0].id, setting.name, LibraryFolderTemplateActions, function (folder) { });
                            } else {
                                lib = new Library(library.libraryId, library.name, library.listId, setting ? setting.listName : '', i19n, vm.accessControlFolderShow, vm.accessControlListShow, function (folder, sender) {
                                    if (!sender && sender != "folderaction") {
                                        vm.folderSelected(folder);
                                    }
                                }, vm.isAdmin());

                                lib.infoText('');
                                lib.folderTemplate = null;
                            }

                            lib.menuItem = new menu.Item(true, 'library');
                            lib.menuItem.libraryId = library.libraryId;                            
                            menu.items().push(lib.menuItem);

                            return lib;
                        });

                        vm.libraries(libraries);

                        d.resolve(libraries);

                        var q1 = _.find(menu.items(), function (itm) {
                            return itm.id == "library" && itm.libraryId && itm.libraryId == sessionStorage.__url_libraryId;
                        });
                        var q2 = _.find(libraries, function (itm) {
                            return itm.libraryId == sessionStorage.__url_libraryId;
                        });

                        if (q1 && q2) {
                            menu.itemSelected(q1);
                            vm.selectedLibrary(q2);
                            
                            _librarySelected(q2, function () {
                                controller.isBusy(false);
                            });
                        } else {
                            controller.isBusy(false);
                        }
                    });
                }
            });

            return d.promise();
        }

        vm.librarySelected = ko.asyncCommand({
            execute: function (library, complete) {
                _librarySelected(library, complete);
            }
        });
        vm.listValueSelected = function (listValue) {            
            sessionStorage.__url_listValueId = listValue.listValueId;
            sessionStorage.__url = window.location.origin + '/#explorer/' + sessionStorage.__url_type + "/" + sessionStorage.__url_libraryId + "/" + sessionStorage.__url_listValueId;
            window.history.pushState('', 'Explorer | fileplan', sessionStorage.__url);            

            ctx.onNavFolder(null);
            //ctx.onDocument(null);

            ctx.saveState(ctx.current.library.libraryId, ctx.current);

            //#region state management
            var state = ctx.loadState(ctx.current.library.libraryId);

            ctx.current = {
                library: ctx.current.library,
                list: ctx.current.library.list,
                listValue: listValue,
                folder: state.folder,
                document: state.document
            };

            ctx.saveState(ctx.current.library.libraryId, ctx.current);
            //#endregion

            var library = ctx.current.library;
            var list = ctx.current.list;

            list.active.selectedRow(listValue);

            ctx
            .loadFoldersForListValue(library, listValue.listValueId)
            .done(function (folders) {
                var folderId = folders.length > 0 ? folders[0].folderId : null;

                if (sessionStorage.__url_folderId) {
                    folderId = sessionStorage.__url_folderId;
                }

                ctx.current.folder = folders.length > 0 ? folders[0] : null;
                
                loadTree(function () {
                    setTimeout(function () { $('#explorer-navigation').animate({ scrollTop: 300 }); }, 500);
                }, library, folders, folderId, listValue.listValueId);
            });
        };
        vm.folderSelected = function (folder) {
            if (!folder) {
                console.warn("folder is null");
                return;
            }                        
            
            sessionStorage.__url_folderId = folder.folderId;

            if (folder.listValueId) {
                sessionStorage.__url = window.location.origin + "/#explorer/" + sessionStorage.__url_type + "/" + sessionStorage.__url_libraryId + "/" + sessionStorage.__url_listValueId + "/" + sessionStorage.__url_folderId;
            } else {
                sessionStorage.__url = window.location.origin + "/#explorer/" + sessionStorage.__url_type + "/" + sessionStorage.__url_libraryId + "/" + sessionStorage.__url_folderId;
            }
            window.history.pushState('', 'Explorer | fileplan', sessionStorage.__url);
            
            ctx.saveState(ctx.current.library.libraryId, ctx.current);

            //#region state management
            var state = ctx.loadState(ctx.current.library.libraryId);

            ctx.current = {
                library: ctx.current.library,
                list: state.list,
                listValue: state.listValue,
                folder: folder,
                document: state.document
            };

            ctx.saveState(ctx.current.library.libraryId, ctx.current);
            //#endregion

            ctx.onNavFolder({ folder: folder, documentId: null });
            
            if (!!folder && folder.libraryId == ctx.current.library.libraryId) {
                if (ctx.current.document == null || ctx.current.document.folderId != folder.folderId) {
                    ctx.onDocument(null);
                }
            }
        };        
        
        vm.refresh = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                refresh(complete, null);
            }
        });
        vm.toggleCollapseExpand = ko.asyncCommand({
            execute: function (complete) {
                var library = ctx.current.library;
                library.treeData.collapseExpand();
                complete();
            }
        });

        vm.createLibrary = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {

                router.navigate("libraries/create");

                complete();
            }
        });

        eventBroker.on(vm, config.events.explorer.navigation.refresh, function (data) {            
            refresh(function () { }, null);
        });

        return vm;

        function _librarySelected(library, complete) {
            sessionStorage.__url_type = library.hasList() ? "library-list" : "library";

            sessionStorage.__url_libraryId = library.libraryId;
            sessionStorage.__url = window.location.origin + '/#explorer/' + sessionStorage.__url_type + "/" + sessionStorage.__url_libraryId;
            window.history.pushState('', 'Explorer | fileplan', sessionStorage.__url);

            ctx.onNavFolder(null);                

            if (ctx.current.library) {
                ctx.saveState(ctx.current.library.libraryId, ctx.current);
            }

            //#region state management
            var state = ctx.loadState(library.libraryId);

            if (state.library) {
                ctx.current = {
                    library: state.library,
                    list: state.list,
                    listValue: state.listValue,
                    folder: state.folder,
                    document: state.document
                };
            } else {
                ctx.current = {
                    library: library,
                    list: null,
                    listValue: null,
                    folder: null,
                    document: null
                };
                ctx.saveState(library.libraryId, ctx.current);
            }
            //#endregion
                
            //menu is closing
            if (!library.menuItem.isSelected()) {
                ctx.onDocument(null);

                return $.Deferred()
                .always(complete)
                .resolve()
                .promise();
            }                
                
            vm.selectedLibrary(library);

            if (library.initialized() && !ctx.pendingRefresh[library.libraryId]) {
                vm.folderSelected(ctx.current.folder);

                return $.Deferred()
                .always(function () {
                    complete();
                })
                .resolve()
                .promise();
            }            

            if (library.hasList()) {
                var filter = sessionStorage.__url_type == "library-list" && sessionStorage.__url_listValueId ? "all" : "auto";

                return ctx.loadListValueForLibrary(library, filter)
                .always(function () {                        
                    if (sessionStorage.__url_listValueId) {
                        var q = _.findWhere(library.list.active.values(), { listValueId: sessionStorage.__url_listValueId });
                        if (q) {                            
                            library.list.active.selectGridRow(q.listValueId);
                        }
                    }

                    if (!!ctx.pendingRefresh[library.libraryId]) {

                        var folderId = ctx.pendingRefresh[library.libraryId].folderId;

                        ctx.pendingRefresh[library.libraryId] = null;

                        //special case for refreshing listvalue since a move from another library prevents full refresh
                        ctx.loadListValueForLibrary(library, library.list.isShowFollow())
                        .done(function () {
                            var list = library.list;
                            var listValue = ctx.current.listValue;
                                
                            if (listValue) {
                                list.active.selectedRow(listValue);

                                ctx.loadFoldersForListValue(library, listValue.listValueId)
                                .done(function (folders) {
                                    if (!folderId && folders.length) {
                                        folderId = folders[0].folderId;
                                    }

                                    loadTree(function () { complete(); }, library, folders, folderId, listValue.listValueId);
                                })
                                .fail(function (e) {
                                    ctx.current.listValue = null;
                                    list.active.selectedRow(null);

                                    loadTree(function () { complete(); }, library, null, null, listValue.listValueId);
                                });
                            } else {
                                loadTree(function () { complete(); }, library, null, null, listValue.listValueId);
                            }
                        })
                        .fail(function (e) {
                            e.stopPropagation = true;

                            complete();
                        });

                    } else {
                        complete();
                    }
                });
            } else {
                return ctx.loadFoldersForLibrary(library)
                .done(function (folders) {
                    var folderId = null;
                        
                    if (sessionStorage.__url_folderId) {
                        folderId = sessionStorage.__url_folderId;
                    }

                    if (!!ctx.pendingRefresh[library.libraryId]) {
                        folderId = ctx.pendingRefresh[library.libraryId].folderId;

                        ctx.pendingRefresh[library.libraryId] = null;
                    }

                    loadTree(function () { complete(); }, library, folders, folderId, null);
                })
                .fail(function (e) {
                    complete();
                });
            }
        }

        function refresh(complete, data) {
            var library = ctx.current.library;            

            if (!data) {
                var folderId = ctx.current.folder ? ctx.current.folder.folderId : null;
                var documentId = ctx.current.document ? ctx.current.document.documentId : null;

                if (library.hasList()) {
                    if (!!ctx.current.listValue && ctx.current.listValue.listValueId == "00000000-0000-0000-0000-000000000000") {
                        complete();
                        return;
                    }
                    
                    ctx.loadListValueForLibrary(library, library.list.isShowFollow()) // "auto"
                    .done(function () {
                        var list = library.list;
                        var listValue = ctx.current.listValue;
                        
                        if (listValue) {
                            list.active.selectedRow(listValue);

                            ctx
                            .loadFoldersForListValue(library, listValue.listValueId)
                            .done(function (folders) {
                                if (!folderId && folders.length) {
                                    folderId = folders[0].folderId;
                                }

                                loadTree(function () { setTimeout(function () { $('#explorer-navigation').animate({ scrollTop: 300 }); complete(); }, 500); }, library, folders, folderId, listValue.listValueId);
                            })
                            .fail(function () {

                                ctx.current.listValue = null;
                                list.active.selectedRow(null);

                                loadTree(complete, library, null, null, listValue.listValueId);
                            })
                            .always(function () { });
                        } else {
                            loadTree(complete, library, null, null, null);
                        }
                    })
                    .fail(function (e) {
                        e.stopPropagation = true;
                        complete();
                    });
                } else {
                    ctx.loadFoldersForLibrary(library)
                    .done(function (folders) {
                        loadTree(complete, library, folders, folderId, null);
                    })
                    .fail(complete);
                }
            } else {
                var folderId = !data.folderId ? (ctx.current.folder ? ctx.current.folder.folderId : null) : data.folderId;
                
                if (folderId) {
                    if (!data.isUpdateNodeOnly) {
                        if (!data.isLoadResults) {
                            library.treeData.selectNode(folderId); //no need to call vm.folderSelected
                            
                        } else {
                            ctx.onDocument(null);
                            
                            ctx.current.document = null;

                            ctx.saveState(ctx.current.library.libraryId, ctx.current);

                            //#region state management
                            var state = ctx.loadState(ctx.current.library.libraryId);

                            ctx.current = {
                                library: ctx.current.library,
                                list: state.list,
                                listValue: state.listValue,
                                folder: state.folder,
                                document: state.document
                            };

                            ctx.saveState(ctx.current.library.libraryId, ctx.current);
                            //#endregion

                            ctx.onNavFolder({ folder: ctx.current.folder, documentId: data.documentId });
                        }
                    }
                    
                    library.treeData._updateNode(folderId, data._updateNode);

                    complete();
                } else {
                    if (ctx.menu.currentItem().id == "checkedout-my") {
                        ctx.onNavMyCheckedOut(null);
                    }
                    if (ctx.menu.currentItem().id == "checkedout-all") {
                        ctx.onNavAllCheckedOut(null);
                    }

                    complete();
                }
            }
        }
        function loadTree(complete, library, folders, folderId, listValueId) {

            library.isShowFolderTemplate(false);

            if (library.hasList() && listValueId == '00000000-0000-0000-0000-000000000000') {
                library.list.folders(null);

                library.loadTree().always(complete);                            

                library.isShowFolderTemplate(true);
                library.folderTemplate.loadTree();                
            }
            else {
                if (library.hasList()) {
                    library.list.folders(folders);                    
                } else {
                    library.folders(folders);
                }

                library.loadTree()
                .done(function () {
                    if (folderId) {                        
                        library.treeData.selectNode(folderId); // no need to call vm.folderSelected
                        library.refreshFolderActions();
                    }
                })
                .always(complete);
            }
        }        
    });
